import React from 'react';
import { Card, CardHeader, CardBody, CardFooter } from '@progress/kendo-react-layout';
import { Icon } from '@progress/kendo-react-common';
import './Stars.scss'
import { ITicketProps } from '../../../../../types/Ticket/ITicket';
import { Skeleton } from '@progress/kendo-react-indicators';
import { Button } from '@progress/kendo-react-buttons'
import * as svg from '@progress/kendo-svg-icons';
import { TicketApi } from '../../../../../redux/api/TicketApi';
import { toast } from 'react-toastify';

//Create a type that extends ITicketProps
interface IStarProps extends ITicketProps {
    EditMode: boolean;
}

const Stars: React.FC<IStarProps> = ({ ID, Rating, Is_Loading, EditMode }) => {
    const [resendRatingEmail, { isLoading: sendingEmail }] = TicketApi.useResendRatingEmailMutation();
    if (!Rating && !EditMode) return null;

    const sendRatingEmail = () => {
        resendRatingEmail(ID).unwrap().then(() => {
            toast.success('Rating email sent successfully');
        });;
    }

    return (
        <Card className="star-rating timeline">
            <CardHeader>
                <Icon size='large' name='star-outline' />Rating<i></i>
            </CardHeader>
            <CardBody>
                {Is_Loading ? <Skeleton shape="rectangle" style={{ width: '100%', height: '100px', marginTop: '2px' }} /> :
                    <div className={`rating-${Rating?.Rating}-stars`}>
                        <div className="rating">
                            <span className="s1" title="Terrible">★</span>
                            <span className="s2" title="Bad">★</span>
                            <span className="s3" title="Okay">★</span>
                            <span className="s4" title="Good">★</span>
                            <span className="s5" title="Great">★</span>
                        </div>
                        {Rating?.Notes && <i className="rating-notes p-1 d-inline-block">"{Rating.Notes}"</i>}
                    </div>}
            </CardBody>
            {Rating?.Rated_Times < 2 && <CardFooter className='flex justify-content-end'>
                {sendingEmail ? <Button imageUrl='./images/ajax-loader-small.gif'>Resend</Button> :
                    <Button svgIcon={svg.paperPlaneIcon} className="mt-1" title='Resend rating email' onClick={() => sendRatingEmail()}>Resend</Button>
                }
            </CardFooter>}
        </Card>);
};

export default Stars;